export default "__VITE_ASSET__978d5c7a__"